// Semáforo de inactividad de un caso en la lista: "hace N días" desde el
// último movimiento (updated_at o última nota). Usa los MISMOS umbrales que
// la escalación del worker (editables en Configuración → Automatizaciones → Tiempos y escalación).

export type NivelActividad = "ok" | "por_quemarse" | "quemado" | "escalacion";

export const ACTIVIDAD_PILL: Record<NivelActividad, string> = {
  ok: "bg-emerald-500/10 text-emerald-300 border-emerald-500/30",
  por_quemarse: "bg-amber-500/10 text-amber-300 border-amber-500/30",
  quemado: "bg-red-500/10 text-red-300 border-red-500/30",
  escalacion: "bg-red-500/10 text-red-300 border-red-500/30",
};

export function textoActividad(dias: number): string {
  if (dias <= 0) return "hoy";
  return `hace ${dias} d`;
}
